import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import AssetLabel from "../components/common/AssetLabel";

export default function TradeConfirmationModal({ show, action, onCancel, onConfirm }) {
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show) {
      setSending(false);
      setError("");
    }
  }, [show]);

  const confirm = async () => {
    if (sending) return;
    setSending(true);
    setError("");
    try {
      await onConfirm();
    } catch (requestError) {
      setError(requestError?.message || "Could not send the trade command");
      setSending(false);
    }
  };

  return (
    <Modal
      show={Boolean(show && action)}
      onHide={sending ? undefined : onCancel}
      centered
      backdrop={sending ? "static" : true}
      keyboard={!sending}
      dialogClassName="tradeConfirmationDialog"
      contentClassName="tradeConfirmationContent"
    >
      <Modal.Header closeButton={!sending} closeVariant="white">
        <Modal.Title>{action?.title}</Modal.Title>
        <span className={`tradeConfirmationSide ${String(action?.side || "").toLowerCase()}`}>
          {action?.side}
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="tradeConfirmationSymbol">
          <AssetLabel symbol={action?.symbol} event={action} />
        </div>
        <div className="tradeConfirmationGrid">
          {(action?.rows || []).map(([label, value]) => (
            <div className="tradeConfirmationMetric" key={label}>
              <span>{label}</span>
              <strong>{value}</strong>
            </div>
          ))}
        </div>
        {action?.notice ? <div className="tradeConfirmationNotice">{action.notice}</div> : null}
        {error ? <div className="tradeConfirmationError" role="alert">{error}</div> : null}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={sending} onClick={onCancel}>Cancel</Button>
        <Button
          variant={action?.confirmVariant || "primary"}
          disabled={sending}
          onClick={confirm}
        >
          {sending ? "Sending..." : action?.confirmLabel || "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
